export default "__VITE_PUBLIC_ASSET__cd879d2f__"